const servers = 20227;
const capacity = 23665.59;
const countries = 145;
const locations = 191;
export { servers, capacity, countries, locations };
